import script from "./IncompleteQuestionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncompleteQuestionsModal.vue?vue&type=script&setup=true&lang=ts"

import "./IncompleteQuestionsModal.vue?vue&type=style&index=0&id=481da6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481da6b2"]])

export default __exports__